module.exports = __webpack_public_path__ + "img/CRT_Weapon-Sword-02.e4ab499c.png";